$(function(){
    // 開くボタンをクリックしたらモーダルを表示する
    $('.modal-open').on('click',function(){ 
        // モーダル表示時にbodyタグのスクロールを禁止する
        $('body').addClass('modal-opened');
        // クリックされたボタンから最も近い親の.modal-containerを探し、activeクラスを追加
        $(this).closest('.multicolumn-card__info').find('.modal-container').addClass('active');
        // クリックされたボタンから最も近い親の.li要素を探し、その親の.activeクラスを追加
        $(this).closest('li').addClass('active');
        return false;
    });

    // 閉じるボタンをクリックしたらモーダルを閉じる
    $('.modal-close').on('click',function(){ 
        // モーダルが閉じられたらbodyタグのスクロール制限を解除する
        $('body').removeClass('modal-opened');
        // クリックされた閉じるボタンが属する.modal-containerからactiveクラスを削除
        $(this).closest('.modal-container').removeClass('active');
        // 閉じるボタンが属する.li要素からactiveクラスを削除
        $(this).closest('li').removeClass('active');
    });

    // モーダルの外側をクリックしたらモーダルを閉じる
    $(document).on('click',function(e) {
        if(!$(e.target).closest('.modal-body').length && !$(e.target).closest('.modal-open').length) {
            // モーダルが閉じられたらbodyタグのスクロール制限を解除する
            $('body').removeClass('modal-opened');
            $('.modal-container').removeClass('active');
            // モーダルの外側をクリックしたら、全ての.multicolumn-card__infoからactiveクラスを削除
            $('.multicolumn-card__info').removeClass('active');
            // モーダルの外側をクリックしたら、全ての.li要素からactiveクラスを削除
            $('li').removeClass('active');
        }
    });
});